"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 2H2v20l4-4h16zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6z"
}), 'MmsSharp');